import actionTypes from "../actions/actionTypes";
import { CANDIDATE_STATUS } from "../constants/constants";
import { decrypt } from "../util/helpers";

const initialState = {
  generalDetails: {
    id: "",
    updatedBy: "",
    roleId: "",
    createdDate: "",
    updatedDate: "",
    status: 0,
    approved: 0
  },
  personalDetails: {},
  qualificationDetails: [],
  addressDetails: [],
  organizationDetails: [],
  candidatesList: [],
  recruitersList: [],
  genders: [],
  maritalStatusList: [],
  states: [],
  userRoles: []
};
export function candidateDetails(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_CANDIDATE_DETAILS:
      return {
        ...state,
        generalDetails: {
          id: action.res.id,
          updatedBy: action.res.updatedBy,
          roleId: action.res.roleId,
          createdDate: action.res.createdDate,
          updatedDate: action.res.updatedDate,
          status: action.res.status,
          approved: action.res.approved
        },
        personalDetails:
          action.res && action.res.userDetails
            ? {
                ...action.res.userDetails,
                panCardNo: decrypt(action.res.userDetails.panCardNo),
                pfUanNo: decrypt(action.res.userDetails.pfUanNo),
                adhaarNumber: decrypt(action.res.userDetails.adhaarNumber),
                isNamesVerified: action.res.status >= CANDIDATE_STATUS.INPROGRESS.id
              }
            : {},
        qualificationDetails: action.res.userDetails.qualifications || [],
        addressDetails: action.res.userDetails.addresses || [],
        organizationDetails: action.res.userDetails.organizationDetails || []
      };
    case actionTypes.SET_CANDIDATE_PERSONAL_DETAILS:
      return {
        ...state,
        personalDetails: {
          ...state.personalDetails,
          [action.fieldName]: action.fieldValue
        }
      };
    case actionTypes.RESET_CANDIDATE_DETAILS:
      return { ...initialState };

    case actionTypes.UPDATE_CANDIDATE_QUALIFICATION_DETAILS: {
      const updatedQualifications = state.qualificationDetails.map(
        qualification => {
          if (qualification.id === action.id)
            return {
              ...qualification,
              [action.fieldName]: action.fieldValue
            };
          return { ...qualification };
        }
      );
      return { ...state, qualificationDetails: updatedQualifications };
    }
    case actionTypes.ADD_CANDIDATE_QUALIFICATION_DETAILS:
      return {
        ...state,
        qualificationDetails: state.qualificationDetails.concat(
          action.newQualification
        )
      };
    case actionTypes.DELETE_CANDIDATE_QUALIFICATION_DETAILS:
      return {
        ...state,
        qualificationDetails: state.qualificationDetails.filter(
          qualification => qualification.id !== action.id
        )
      };
    case actionTypes.UPDATE_CANDIDATE_ADDRESS_DETAILS: {
      const updatedAddress = state.addressDetails.map(address => {
        if (address.id === action.id)
          return {
            ...address,
            [action.fieldName]: action.fieldValue
          };
        return { ...address };
      });
      return { ...state, addressDetails: updatedAddress };
    }
    case actionTypes.ADD_CANDIDATE_ADDRESS_DETAILS:
      return {
        ...state,
        addressDetails: state.addressDetails.concat(action.newAddress)
      };
    case actionTypes.UPDATE_CANDIDATE_ADDRESS_DETAILS_ALL: {
      const updatedAddress = state.addressDetails.map(address => {
        if (address.id === action.id)
          return {
            ...address,
            ...action.addressDetails
          };
        return { ...address };
      });
      return { ...state, addressDetails: updatedAddress };
    }
    case actionTypes.UPDATE_CANDIDATE_ORGANIZATON_DETAILS: {
      const updatedOrganizations = state.organizationDetails.map(
        organization => {
          if (organization.id === action.id)
            return {
              ...organization,
              [action.fieldName]: action.fieldValue
            };
          return { ...organization };
        }
      );
      return { ...state, organizationDetails: updatedOrganizations };
    }

    case actionTypes.ADD_CANDIDATE_ORGANIZATON_DETAILS:
      return {
        ...state,
        organizationDetails: state.organizationDetails.concat(
          action.newOrganization
        )
      };
    case actionTypes.DELETE_CANDIDATE_ORGANIZATON_DETAILS:
      return {
        ...state,
        organizationDetails: state.organizationDetails.filter(
          organization => organization.id !== action.id
        )
      };
    case actionTypes.GET_CANDIDATES_LIST:
      return {
        ...state,
        candidatesList: action.res
      };
    case actionTypes.UPDATE_CANDIDATES_LIST: {
      const updatedList = state.candidatesList.map(candidate => {
        if (candidate.id === action.id)
          return {
            ...candidate,
            [action.fieldName]: action.fieldValue
          };
        return { ...candidate };
      });
      return { ...state, candidatesList: updatedList };
    }
    case actionTypes.GET_RECRUITERS_LIST:
      return {
        ...state,
        recruitersList: action.res
      };
    case actionTypes.GET_GENDERS_LIST:
      return {
        ...state,
        genders: action.res
      };
    case actionTypes.GET_USER_ROLES:
      return {
        ...state,
        userRoles: action.res
      };
    case actionTypes.GET_MARITAL_STATUS_LIST:
      return {
        ...state,
        maritalStatusList: action.res
      };
    case actionTypes.GET_STATES_LIST:
      return {
        ...state,
        states: action.res
      };
    default:
      return state;
  }
}
